module.exports = __webpack_public_path__ + "static/media/target.c85fd505.svg";